import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    const err = error instanceof Error ? error : new Error(JSON.stringify(error));

  if (err.stack?.includes('zone.js')) {
    return;
  }

  const ignoredMessages = [
    'ResizeObserver loop limit exceeded',
    'Script error.'
  ];
  if (ignoredMessages.some(msg => err.message.includes(msg))) {
    return;
  }

  if ((window as any).dtrum) {
    (window as any).dtrum.reportError(err);
  }
}

}
